import {Button} from '@/components/ui/button/Button'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {ChevronLeftIcon, ChevronRightIcon} from '@/components/ui/icon/Icon'
import {Text} from '@/components/ui/text/Text'
import {formatLocaleDate} from '@/dayjs'
import dayjs from 'dayjs'
import {useMemo} from 'react'

export const DoctorTherapistDatesRange = ({
    dateRange,
    setDateRange,
    isDisabled
}: {
    dateRange: [string, string]
    setDateRange: (dateRange: [string, string]) => void
    isDisabled: boolean
}) => {
    const currentWeekDates = {
        start: formatLocaleDate(dayjs(dateRange[0]).startOf('week').toDate(), 'll'),
        end: formatLocaleDate(dayjs(dateRange[1]).endOf('week').toDate(), 'll')
    }

    const handleBack = () => {
        setDateRange([
            dayjs(dateRange[0]).subtract(1, 'week').format('YYYY-MM-DD'),
            dayjs(dateRange[1]).subtract(1, 'week').format('YYYY-MM-DD')
        ])
    }
    const handleNext = () => {
        setDateRange([
            dayjs(dateRange[0]).add(1, 'week').format('YYYY-MM-DD'),
            dayjs(dateRange[1]).add(1, 'week').format('YYYY-MM-DD')
        ])
    }

    const isCurrentWeek = useMemo(() => {
        return dayjs(dateRange[0]).isSame(dayjs(), 'week') && dayjs(dateRange[1]).isSame(dayjs(), 'week')
    }, [dateRange])

    return (
        <Flexbox align="center" justify="space-between" fullWidth>
            <Button
                size="sm"
                variant="secondary"
                shape="square"
                onClick={handleBack}
                disabled={isDisabled || isCurrentWeek}
            >
                <ChevronLeftIcon />
            </Button>
            <Text palette="neutral" shade="950" weight={500} size="textSm">
                {currentWeekDates.start} - {currentWeekDates.end}
            </Text>
            <Button size="sm" variant="secondary" shape="square" onClick={handleNext} disabled={isDisabled}>
                <ChevronRightIcon />
            </Button>
        </Flexbox>
    )
}
